import { render } from "./EtatPointCommande.vue?vue&type=template&id=22b6f547&ts=true"
import script from "./EtatPointCommande.vue?vue&type=script&lang=ts"
export * from "./EtatPointCommande.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__